// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7696b903","703":"9ea00c41","787":"7efd31bd"}[chunkId] + ".chunk.js";
};